/**
 * Campaign (Season of Gifting / "Campus Drop") social-preview constants.
 *
 * Two routes render the same share card — `/campus-drop` (the branded
 * canonical we share and blast) and `/season-of-gifting/` (the funnel's own
 * landing) — so the strings live here rather than in either one. They were
 * previously inline in `app/season-of-gifting/index.tsx`, which meant the
 * branded alias shipped with no campaign meta at all.
 *
 * Static on purpose: scrapers read the exported HTML and never run JS, so
 * these can't be server-driven. A campaign rename means editing this file
 * and redeploying web.
 */
import { APP_BASE_URL } from './og';

/**
 * The canonical campaign URL, and the one `campaignShareUrl()` hands to the
 * share sheet.
 *
 * It is `/campus-drop`, NOT `/season-of-gifting`, for a reason caught two
 * days before launch: EAS Hosting serves the static export as plain files,
 * and it will not resolve an extensionless request to a directory index. `/season-of-gifting` is a directory (it has
 * children — start, choose, confirm…), so the bare path missed
 * `season-of-gifting/index.html` and fell through to `+not-found.html`.
 * Verified against prod: the bare path returned the not-found shell and its
 * generic OG, `/season-of-gifting/` with a trailing slash returned the real
 * page. `/campus-drop` is a leaf route, so it exports as a real
 * `campus-drop.html` file and needs no trailing-slash trick — which is the
 * point, since a trailing slash is the kind of detail a future URL
 * normalization silently strips.
 */
export const CAMPAIGN_URL = `${APP_BASE_URL}/campus-drop`;

/** Canonical for BOTH routes, so shares of either dedupe onto one card. */
export const CAMPAIGN_OG_URL = CAMPAIGN_URL;

export const CAMPAIGN_OG_TITLE = 'Back-to-School Campus Drop — MarketPryce Rewards';

/**
 * Keep this under ~100 characters. iMessage gives a share card about two
 * short lines of description on a phone and truncates the rest — the
 * previous copy opened with "New semester, new NIL deal." and ran to 116,
 * so the throat-clearing survived and "No required post." (the line that
 * answers "what's the catch?") was what got cut.
 */
export const CAMPAIGN_OG_DESCRIPTION =
  'Claim one free product from a MarketPryce brand. No required post.';

/**
 * Campaign-specific share preview, served from the web export's `public/`.
 * Unlike the deal pages (which fall back to the square MP monogram) this is
 * a real 1.91:1 card, so iMessage and X render the large layout.
 */
export const CAMPAIGN_OG_IMAGE = `${APP_BASE_URL}/season-of-gifting-og.jpg`;
export const CAMPAIGN_OG_IMAGE_WIDTH = '1206';
export const CAMPAIGN_OG_IMAGE_HEIGHT = '632';
